import { render } from "./KeyValue.vue?vue&type=template&id=8f9c0fb0"
import script from "./KeyValue.vue?vue&type=script&lang=js"
export * from "./KeyValue.vue?vue&type=script&lang=js"

import "./KeyValue.vue?vue&type=style&index=0&id=8f9c0fb0&lang=scss"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__